var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 104,
    viewBox: "0 0 43 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1689)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.981 26.68H4.261V14.32c11.52 0 14.28-2.64 15.96-9.96h12.48v89.28h-15.72V26.68z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.981 26.68H4.261V14.32c11.52 0 14.28-2.64 15.96-9.96h12.48v89.28h-15.72V26.68z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1689",
    x: -4.239,
    y: -4.14,
    width: 46.44,
    height: 107.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1689"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1689",
    result: "effect2_dropShadow_2805_1689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1689",
    result: "shape"
  })))));
}
Svg1.displayName = '1';
export default Svg1;